import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { SecondaryButton } from "../Common/SecondaryButton";

interface CapEventModalProps {
    onClose: () => void;
    isOpen: boolean;
    onConfirm: (cap: number) => void;
    isLoading: boolean;
    eventCapacity: number;
}

export const CapEventModal = ({ onClose, isOpen, onConfirm, isLoading, eventCapacity }: CapEventModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Modal.Header>Cap Event</Modal.Header>
            <Modal.Body>
                <div className="space-y-4" data-testid="cap-event-modal-message">
                    <p className="p1">
                        Are you sure you want to cap this event? This event’s capacity will be updated to&nbsp;
                        {eventCapacity} and will no longer accept any new reservations.
                    </p>
                    <p className="p1">
                        Active reservations for this event will be retained. Reservationists will still be able to
                        modify capacity manually.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <SecondaryButton disabled={isLoading} onClick={onClose}>
                    Cancel
                </SecondaryButton>
                <SubmitButton color="danger" isLoading={isLoading} onClick={onConfirm}>
                    Confirm
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};
